var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{staticStyle:{"height":"800px","background":"#FFFFFF"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }